import React, { useState } from "react";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';
import ReactExport from "react-data-export";
import moment from "moment";
import { BotonExcel } from "./../Plantillas/Botones";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const TablaDetalleDespachos = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div className="alert alert-warning mt-3 shadow-sm border-0">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                No hay datos detallados disponibles para este rango de fechas.
            </div>
        );
    }

    const cols = [
        {
            Header: "Serie",
            accessor: "Serie",
            width: 100,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Serie"] }),
            filterAll: true
        },
        {
            Header: "Comprobante",
            accessor: "NumeroComprobante",
            width: 100,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["NumeroComprobante"] }),
            filterAll: true
        },
        {
            Header: "Alias",
            accessor: "PlacaAlias",
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["PlacaAlias"] }),
            filterAll: true
        },
        {
            Header: "Cliente",
            accessor: "NombreCliente",
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["NombreCliente"] }),
            filterAll: true
        },
        {
            Header: "Total Venta",
            accessor: "MontoTotalVenta",
            width: 120,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["MontoTotalVenta"] }),
            filterAll: true
        },
        {
            Header: "Despachador",
            accessor: "OperarioDespachador",
            width: 120,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["OperarioDespachador"] }),
            filterAll: true
        },
        {
            Header: "Vendedor",
            accessor: "Vendedor",
            width: 120,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Vendedor"] }),
            filterAll: true
        },
        {
            Header: "Tiempo en Cola",
            accessor: "TiempoEnColaFormateado",
            width: 130,
            style: { textAlign: 'center' }
        },
        {
            Header: "Tiempo en Proceso",
            accessor: "TiempoEnProcesoFormateado",
            width: 150,
            style: { textAlign: 'center' }
        },
        {
            Header: "Tiempo Total",
            accessor: "TiempoFormateado",
            width: 120,
            style: { textAlign: 'center' },
            Cell: ({ value }) => <strong>{value}</strong>
        }
    ];

    const getExcelData = () => {
        const headerStyle = {
            fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } },
            font: { bold: true }
        };

        const columns = [
            { title: "ID Despacho", width: { wpx: 100 } },
            { title: "Serie", width: { wpx: 100 } },
            { title: "Comprobante", width: { wpx: 120 } },
            { title: "Alias", width: { wpx: 150 } },
            { title: "Cliente", width: { wpx: 250 } },
            { title: "Total Venta", width: { wpx: 100 } },
            { title: "Operario", width: { wpx: 120 } },
            { title: "Vendedor", width: { wpx: 120 } },
            { title: "Cant. Prod.", width: { wpx: 100 } },
            { title: "Total Unid.", width: { wpx: 100 } },
            { title: "Inicio Pendiente", width: { wpx: 160 } },
            { title: "Finalización", width: { wpx: 160 } },
            { title: "Tiempo Cola", width: { wpx: 100 } },
            { title: "Tiempo Proceso", width: { wpx: 120 } },
            { title: "Tiempo Total", width: { wpx: 100 } }
        ];

        const exportData = data.map(row => [
            { value: row.IdDespacho || "", style: headerStyle },
            { value: row.Serie || "", style: headerStyle },
            { value: row.NumeroComprobante || "", style: headerStyle },
            { value: row.PlacaAlias || "", style: headerStyle },
            { value: row.NombreCliente || "", style: headerStyle },
            { value: row.MontoTotalVenta || 0, style: headerStyle },
            { value: row.OperarioDespachador || "", style: headerStyle },
            { value: row.Vendedor || "", style: headerStyle },
            { value: row.CantidadProductos || 0, style: headerStyle },
            { value: row.TotalUnidades || 0, style: headerStyle },
            { value: row.FechaInicioPendiente ? moment(row.FechaInicioPendiente).format('DD/MM/YYYY HH:mm:ss') : "", style: headerStyle },
            { value: row.FechaFinalizacion ? moment(row.FechaFinalizacion).format('DD/MM/YYYY HH:mm:ss') : "", style: headerStyle },
            { value: row.TiempoEnColaFormateado || "", style: headerStyle },
            { value: row.TiempoEnProcesoFormateado || "", style: headerStyle },
            { value: row.TiempoFormateado || "", style: headerStyle }
        ]);

        return [{ columns, data: exportData }];
    };

    return (
        <div className="card border-0 shadow-sm mt-3 mb-5" style={{ background: 'none' }}>
            <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: 'rgba(53, 96, 90, 0.08)' }}>
                <h6 className="mb-0" style={{ color: '#35605a' }}>
                    <i className="fas fa-list-alt mr-2"></i>Detalle de Despachos Individuales
                </h6>
                <ExcelFile
                    element={<BotonExcel className="btn-sm" title="Exportar Detalle" />}
                    filename={`DetalleDespachos_${moment().format('YYYYMMDD_HHmmss')}`}
                >
                    <ExcelSheet dataSet={getExcelData()} name="Detalle" />
                </ExcelFile>
            </div>
            <div className="card-body p-0">
                <ReactTable
                    data={data}
                    columns={cols}
                    filterable={true}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText='Ant'
                    nextText='Sig'
                    pageText='Pág'
                    ofText='de'
                    rowsText='filas'
                    noDataText='No hay registros'
                />
            </div>
        </div>
    );
};

export default TablaDetalleDespachos;
